import React, { useState } from "react"
import ProgressBar from "./ProgressBar"
import { Card, Tooltip } from "reactstrap"
import { Link } from "react-router-dom"
import PasswordToolTip from "./PasswordToolTip"

//ui-cmd-3
const CustomCard = ({ titleText, DescriptionComponent, buttonsList, customBtnLoading, children, IsPrimaryButtonDisabled, applicationLoading, applicationDelLoading = false, className }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const toggleTooltip = () => {
        setIsTooltipOpen(!isTooltipOpen)
    }

    return (
        <React.Fragment>
            <Card className={`layout-card ${className ? className : ""}`}>
                <div className="card-container">
                    <div className="card-header-container">
                        <span className="title">{titleText}</span>
                        <div style={{ display: 'flex' }}>
                            {buttonsList && buttonsList.map((button, index) => (
                                button.buttonType === "icon" ?
                                    <div
                                        className={`button-delete ${button?.buttonText === "closeGetStarted" ? "close-get-started" : ""}  ${applicationDelLoading ? "button-disabled" : ""}`}
                                        onClick={button.callBackFunction}
                                    >
                                        <img src={button?.buttonIcon} />
                                        {(applicationDelLoading) &&
                                            <div className="spinner-container spinner-border">
                                            </div>}
                                    </div>
                                    :
                                    button?.path ?
                                        <Link to={`${button?.path}`} key={index} target={button?.redirectNewPage ? "_blank" : ""}>
                                            <button
                                                id={button?.tooltipId}
                                                disabled={IsPrimaryButtonDisabled || (button?.buttonType === 'primary' && applicationLoading)}
                                                onClick={button.callBackFunction} className={`${button?.buttonType === 'primary' ? applicationLoading ? 'button-background button-disabled' : 'button-background' : 'button'} ${IsPrimaryButtonDisabled ? 'button-disabled' : ''}`}>{button.buttonText}
                                                {(button?.buttonType === 'primary' && applicationLoading) &&
                                                    <div className="spinner-container spinner-border">
                                                    </div>}
                                            </button>
                                            {(button?.tooltipText && IsPrimaryButtonDisabled) &&
                                                <Tooltip
                                                    className="custom-tooltip"
                                                    placement="top-start"
                                                    isOpen={isTooltipOpen}
                                                    target={button?.tooltipId}
                                                    toggle={toggleTooltip}
                                                >
                                                    {button?.tooltipText}
                                                </Tooltip>
                                            }




                                        </Link>
                                        :
                                        <button
                                            disabled={customBtnLoading || IsPrimaryButtonDisabled || (button?.buttonType === 'primary' && applicationLoading)}
                                            onClick={button.callBackFunction}
                                            className={`${button?.buttonType === 'primary' ? applicationLoading ? 'button-background button-disabled' : 'button-background' : 'button'} ${IsPrimaryButtonDisabled ? 'button-disabled' : ''} ${customBtnLoading ? 'button-disabled' : ''}`}>
                                            {button.buttonText}
                                            {(button?.buttonType === 'primary' && applicationLoading) &&
                                                <div className="spinner-container spinner-border">
                                                </div>}
                                        </button>

                            ))}


                        </div>

                    </div>
                    <div className="line-break" />
                    <div className="vard-description-container">
                        {children && children}
                    </div>
                </div>
            </Card>
        </React.Fragment>
    )
}

export default CustomCard
